import * as yup from "yup";

const addAndChangeSchemaAudit = (translate: Function) => yup.object().shape({
	adb001Tipo: yup.number().required(translate("Tipo é requerido")),
	adb001Titulo: yup.string().required(translate("Título é requerido")).max(200, translate("Título deve conter no máximo 200 caracteres")),
	adb001Descricao: yup.string().required(translate("Descrição é requerida")),
	adb001Taa001Id: yup.number().required(translate("Setor é requerido")),
	adb001Taa005Id: yup.number().required(translate("Processo é requerido")),
	adtbb002: yup.array().of(yup.object().shape({
		adb002Nomeauditor:  yup.string().when("type", {
			is: "f",
			then: yup.string().required(translate("Auditor Externo é requerido"))
		}),
		adb002Efa005Id:  yup.string().when("type", {
			is: "u",
			then: yup.string().required(translate("Nome Usuário é requerido"))
		})
	}))
		.unique(translate("Auditores não podem ser repetidos"), (a: any) => a.adb002Efa005Id, (a: any) => a.type === "u")
		.unique(translate("Auditores externos não podem ser repetidos"), (a: any) => a.adb002Nomeauditor, (a: any) => a.type === "f"),
	adtbb003: yup.array().of(yup.object().shape({
		adb003Nomeparticipante:  yup.string().when("type", {
			is: "f",
			then: yup.string().required(translate("Participante Externo é requerido"))
		}),
		adb003Efa005Id:  yup.string().when("type", {
			is: "u",
			then: yup.string().required(translate("Nome Usuário é requerido"))
		})
	}))
		.unique(translate("Participantes não podem ser repetidos"), (a: any) => a.adb003Efa005Id, (a: any) => a.type === "u")
		.unique(translate("Participantes externos não podem ser repetidos"), (a: any) => a.adb003Nomeparticipante, (a: any) => a.type === "f"),
	adtbb004: yup.array().of(yup.object().shape({
		adb004Codigo:  yup.string().required(translate("Código é requerido")),
		adb004Descricao: yup.string().required(translate("Descrição é requerida"))
	}))
		.unique(translate("Códigos dos itens não podem ser repetidos"), (a: any) => a.adb004Codigo)
		.unique(translate("Descrição dos itens não podem ser repetidos"), (a: any) => a.adb004Descricao)
});

const deleteSchemaAudit = (translate: Function) => yup.object().shape({
	adb001Titulo: yup.string().required(translate("Título da auditoria não confere")).oneOf([yup.ref("adb001TituloConfirmation")], translate("Título da auditoria não confere"))
});

export { addAndChangeSchemaAudit, deleteSchemaAudit };
